export default __webpack_public_path__ + "static/media/voice-and-tone.6ba123ec.svg";